'use strict';
/* Controllers for the chargify feature */
/**
 * Main screen controller for the messaging screen
 */
angular.module('autoremind.admin.chargify', [])
    .controller('autoremind.admin.chargify.ScreenController', 
// Setup dependencies
['$scope', '$http', '$filter', 'logger', 'userProfile', 'accountService', 'chargifyService', '$routeParams', '$location',
    function ($scope, $http, $filter, logger, userProfile, accountService, chargifyService, $routeParams, $location) {
        logger.info('In autoremind.admin.chargify.ScreenController');
        userProfile.getProfileIfNotLoaded(function () {
            logger.debug('autoremind.admin.chargify.ScreenController: got user profile');
        });
        userProfile.initalizeViewModel("admin");
        if (!angular.isDefined(userProfile.viewModel.views.admin)) {
            userProfile.viewModel.views.admin = {};
        }
        // Sometimes- the viewModel.views.admin.chargify comes as {} and throws error, so we added additional check of activeTabIndex
        if (!angular.isDefined(userProfile.viewModel.views.admin.chargify) || !angular.isDefined(userProfile.viewModel.views.admin.chargify.activeTabIndex)) {
            userProfile.viewModel.views.admin.chargify = {
                activeTabIndex: 0,
                tabIndexes: {
                    subscriptionsReconcile: 0,
                    messageBilling: 1
                },
                loadingIndicator: {
                    'state': false, 'refCount': 0
                }
            };
        }
        $scope.viewModel = userProfile.viewModel.views.admin.chargify;
        $scope.setRoute = function (tab) {
            if (!angular.isDefined($scope.viewModel.tabIndexes[tab])) {
                tab = 'subscriptionsReconcile';
            }
            $scope.viewModel.activeTabIndex = $scope.viewModel.tabIndexes[tab];
            var newPath = '/admin/chargify/' + tab;
            if ($location.path() !== newPath) {
                $location.path(newPath, false);
            }
        };
        /**
         * Only run this once when the page loads (not on changing tabs)
         */
        $scope.init = function () {
            switch ($location.path()) {
                case '/admin/chargify/':
                case '/admin/chargify/subscriptionsReconcile':
                    $scope.setRoute('subscriptionsReconcile');
                    break;
                case '/admin/satellites/messageBilling':
                    $scope.setRoute('messageBilling');
                    break;
            }
        };
        $scope.init();
    }]);
//# sourceMappingURL=chargify.controllers.js.map